var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Route, Routes } from 'react-router-dom';
import AccountNavigations from './navigations';
import AccountBanner from './banner';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import ComponentSwitcher from './component';
import { useQuery } from '@tanstack/react-query';
import ImportAxios from '@themes/common/axios';
import useCustomerReducer from './useCustomerReducer';
import { useEffect } from 'react';
import useIsMobile from './components/useIsMobile';
import useMobileActiveMenu from './components/useMobileActiveMenu';
export const Layout = ({ menuItems }) => {
    const [{ shopifyCustomer }, setCustomer] = useCustomerReducer();
    const isMoble = useIsMobile();
    const [mobileMenuActiveState] = useMobileActiveMenu();
    const { data: customer, isLoading } = useQuery({
        queryKey: ['customer_informations'],
        cacheTime: 5 * 60 * 1000,
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            if (!shopifyCustomer) {
                return null;
            }
            const axios = yield ImportAxios();
            const result = yield axios.get(`${process.env.HOST}/api/customers/${shopifyCustomer.id}`, {
                params: {
                    organisationNumber: shopifyCustomer.metafields['SB-C']['OrganizationNumber'],
                    monitorCustomerId: shopifyCustomer.metafields['SB-C']['CustomerId'],
                },
            });
            return result.data;
        }),
    });
    useEffect(() => {
        if (customer)
            setCustomer((state) => {
                state.customer = customer;
            });
    }, [setCustomer, customer]);
    return (_jsxs(Stack, Object.assign({ component: 'main', role: 'main', "aria-label": 'Konto information', className: 'page__container', sx: {
            marginTop: '0 !important',
        }, spacing: isMoble ? 1 : 2 }, { children: [_jsx(AccountBanner, { menuItems: menuItems }), _jsxs(Grid, Object.assign({ container: true, alignItems: 'stretch' }, { children: [_jsx(Grid, Object.assign({ item: true, xs: 12, md: 2, component: 'nav', role: 'navigation', "aria-label": 'Konto navigation' }, { children: _jsx(AccountNavigations, { menuItems: menuItems }) })), _jsx(Grid, Object.assign({ item: true, xs: 12, md: 10, component: 'section', role: 'region', "aria-label": 'Inneh\u00E5ll', sx: isMoble && !mobileMenuActiveState.activePath
                            ? {
                                display: 'none',
                                visibility: 'hidden', // Better for screen readers when hidden
                            }
                            : undefined }, { children: _jsx(Routes, { children: menuItems.map((item) => (_jsx(Route, { path: item.url, element: _jsx("div", Object.assign({ "aria-labelledby": `section-heading-${item.id}` }, { children: _jsx(ComponentSwitcher, Object.assign({}, item)) })) }, item.id))) }) }))] })), _jsx("div", Object.assign({ role: 'status', "aria-live": 'polite', className: 'visually-hidden' }, { children: isLoading ? 'Laddar information...' : 'Information laddad' }))] })));
};
